var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns",style:(_vm.cssVars)},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.slide.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }